/**
 * Medal fills for podium trophy SVGs.
 * Use these as explicit `fill` values (not currentColor): inside <Link>, inherited
 * text color overrides Tailwind text-* on the SVG and paints trophies black.
 */
export const RANKING_TROPHY_FILLS = {
  1: "#eab308", // gold (Tailwind yellow-500)
  2: "#cbd5e1", // silver (slate-300)
  3: "#FB8C00", // bronze (orange-600)
}
